import { MarkAnimationParams } from './MarkAnimationParams';
import { FractionWarperCurve } from './MarkAnimationTiming';

/**
 * Aggregated animation parameters for all mark phases in a pane.
 *
 * C++ Reference: MarkAllAnimationParams in tabanim/main/sceneanimation/MarkAllAnimationParams.h
 */
export class MarkAllAnimationParams {
  enterParams: MarkAnimationParams;
  moveParams: MarkAnimationParams;
  exitParams: MarkAnimationParams;
  nonMarksParams: MarkAnimationParams;
  overallFractionWarperCurve: FractionWarperCurve;

  constructor(
    enterParams: MarkAnimationParams,
    moveParams: MarkAnimationParams,
    exitParams: MarkAnimationParams,
    nonMarksParams: MarkAnimationParams,
    overallFractionWarperCurve: FractionWarperCurve
  ) {
    this.enterParams = enterParams;
    this.moveParams = moveParams;
    this.exitParams = exitParams;
    this.nonMarksParams = nonMarksParams;
    this.overallFractionWarperCurve = overallFractionWarperCurve;
  }

  allFourParams(): MarkAnimationParams[] {
    return [this.enterParams, this.moveParams, this.exitParams, this.nonMarksParams];
  }

  clone(): MarkAllAnimationParams {
    return new MarkAllAnimationParams(
      this.enterParams.clone(),
      this.moveParams.clone(),
      this.exitParams.clone(),
      this.nonMarksParams.clone(),
      this.overallFractionWarperCurve
    );
  }

  toDebugString(): string {
    return (
      `enter=${this.enterParams.toDebugString()} ` +
      `move=${this.moveParams.toDebugString()} ` +
      `exit=${this.exitParams.toDebugString()} ` +
      `nonMarks=${this.nonMarksParams.toDebugString()}`
    );
  }
}
